module.exports = __webpack_public_path__ + "img/leads.46d3c41d.svg";